export default "__VITE_ASSET__102b38a6__"